import React from 'react';
import { cn } from '@/lib/utils';
import Icon, { IconComponent } from './Icon';

interface InlineStatusProps {
  icon: IconComponent;
  tone?: 'neutral' | 'danger';
  children: React.ReactNode;
  className?: string;
}

/** Small icon + text line, e.g. a countdown or a validation message. */
const InlineStatus: React.FC<InlineStatusProps> = ({ icon, tone = 'neutral', children, className }) => (
  <p
    role={tone === 'danger' ? 'alert' : undefined}
    aria-live={tone === 'neutral' ? 'polite' : undefined}
    className={cn(
      'tw-flex tw-items-center tw-gap-1.5 tw-text-[14px] tw-leading-5',
      tone === 'danger' ? 'tw-font-semibold tw-text-ds-danger-fg' : 'tw-font-medium tw-text-ds-text-secondary',
      className,
    )}
  >
    <Icon icon={icon} size={16} className={tone === 'neutral' ? 'tw-text-ds-text-tertiary' : undefined} />
    <span>{children}</span>
  </p>
);

export default InlineStatus;
